export default Object.freeze({
    NO_MATCHES: 'No matches',
    MULTIPLE_MATCHES: 'Multiple matches',
    VERIFIED_MATCH: 'Verified match'
  })
  